import { getRooms } from '@/libs/v1/api/client';
import Store from '@/store';

export function updateRooms(rooms: any[]) {
  Store.commit('updateRooms', rooms);
}

export function updateSelectedRoomIds(roomIds: string[]) {
  Store.commit('updateSelectedRoomIds', roomIds);
}

export function resetSelectedRoomIds() {
  Store.commit('resetSelectedRoomIds');
}

export async function loadRooms(targetName: string) {
  try {
    const rooms = await getRooms({ targetName });
    updateRooms(rooms);
  } catch (e) {
    updateRooms([]);
    throw e;
  }
}
